import SummarizeIcon from "@mui/icons-material/Summarize";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleOutline from "@mui/icons-material/CheckCircleOutline";
import ErrorOutline from "@mui/icons-material/ErrorOutline";
import VisibilityRoundedIcon from "@mui/icons-material/VisibilityRounded";
import VisibilityOffRoundedIcon from "@mui/icons-material/VisibilityOffRounded";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import FilterAltRoundedIcon from "@mui/icons-material/FilterAltRounded";
import ImportExportRoundedIcon from "@mui/icons-material/ImportExportRounded";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import ContentCopyRoundedIcon from "@mui/icons-material/ContentCopyRounded";
import FavoriteBorderRoundedIcon from "@mui/icons-material/FavoriteBorderRounded";
import FavoriteRoundedIcon from "@mui/icons-material/FavoriteRounded";
import KeyboardDoubleArrowRightRoundedIcon from "@mui/icons-material/KeyboardDoubleArrowRightRounded";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import SaveAltRoundedIcon from "@mui/icons-material/SaveAltRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import ShareRoundedIcon from "@mui/icons-material/ShareRounded";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import ForumRoundedIcon from "@mui/icons-material/ForumRounded";
import MenuBookRoundedIcon from "@mui/icons-material/MenuBookRounded";
import SendRoundedIcon from "@mui/icons-material/SendRounded";
import { CheckBoxOutlineBlankOutlined, CheckBoxOutlined, Description, Logout, Refresh } from "@mui/icons-material";
import SpaceDashboardRoundedIcon from "@mui/icons-material/SpaceDashboardRounded";
import SettingsRoundedIcon from "@mui/icons-material/SettingsRounded";
import WorkspacePremiumRoundedIcon from "@mui/icons-material/WorkspacePremiumRounded";
import AccountCircleRoundedIcon from "@mui/icons-material/AccountCircleRounded";
import ApartmentRoundedIcon from "@mui/icons-material/ApartmentRounded";
import WorkRoundedIcon from "@mui/icons-material/WorkRounded";
import AccessibleForwardRoundedIcon from "@mui/icons-material/AccessibleForwardRounded";
import FolderOutlinedIcon from "@mui/icons-material/FolderOutlined";
import FolderOpenOutlinedIcon from "@mui/icons-material/FolderOpenOutlined";
import ArrowDropDownRoundedIcon from "@mui/icons-material/ArrowDropDownRounded";
import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import HighlightOffRoundedIcon from "@mui/icons-material/HighlightOffRounded";
import SaveIcon from "@mui/icons-material/Save";
import ClearAllRoundedIcon from "@mui/icons-material/ClearAllRounded";
import UpcomingRoundedIcon from "@mui/icons-material/UpcomingRounded";
import HistoryRoundedIcon from "@mui/icons-material/HistoryRounded";
import LockRoundedIcon from "@mui/icons-material/LockRounded";
import BugReportIcon from "@mui/icons-material/BugReport";
import LocalMallRoundedIcon from "@mui/icons-material/LocalMallRounded";
import SupervisorAccountRoundedIcon from "@mui/icons-material/SupervisorAccountRounded";
import GavelRoundedIcon from "@mui/icons-material/GavelRounded";
import OpenInNewRoundedIcon from "@mui/icons-material/OpenInNewRounded";
import SwapHorizRoundedIcon from "@mui/icons-material/SwapHorizRounded";
import AttachFileRoundedIcon from "@mui/icons-material/AttachFileRounded";

export const icon = {
    switch: SwapHorizRoundedIcon,
    law: GavelRoundedIcon,
    users: SupervisorAccountRoundedIcon,
    shop: LocalMallRoundedIcon,
    lock: LockRoundedIcon,
    newsletter: UpcomingRoundedIcon,
    clear: ClearAllRoundedIcon,
    block: HighlightOffRoundedIcon,
    check: CheckCircleOutlineRoundedIcon,
    dropdown: ArrowDropDownRoundedIcon,
    debug: BugReportIcon,
    accessibility: AccessibleForwardRoundedIcon,
    work: WorkRoundedIcon,
    company: ApartmentRoundedIcon,
    profile: AccountCircleRoundedIcon,
    premium: WorkspacePremiumRoundedIcon,
    settings: SettingsRoundedIcon,
    dashboard: SpaceDashboardRoundedIcon,
    docs: MenuBookRoundedIcon,
    chat: ForumRoundedIcon,
    send: SendRoundedIcon,
    info: InfoOutlinedIcon,
    delete: DeleteRoundedIcon,
    share: ShareRoundedIcon,
    save: SaveAltRoundedIcon,
    openChat: KeyboardDoubleArrowRightRoundedIcon,
    copy: ContentCopyRoundedIcon,
    likeOff: FavoriteBorderRoundedIcon,
    like: FavoriteRoundedIcon,
    add: AddRoundedIcon,
    search: SearchRoundedIcon,
    filter: FilterAltRoundedIcon,
    order: ImportExportRoundedIcon,
    edit: EditRoundedIcon,
    showPassword: VisibilityRoundedIcon,
    hidePassword: VisibilityOffRoundedIcon,
    error: ErrorOutline,
    success: CheckCircleOutline,
    close: CloseIcon,
    menu: MenuIcon,
    summarize: SummarizeIcon,
    book: MenuBookIcon,
    back: ArrowBackRoundedIcon,
    arrowRight: ArrowForwardIcon,
    linkedIn: LinkedInIcon,
    refresh: Refresh,
    logout: Logout,
    folder: FolderOutlinedIcon,
    folderOpen: FolderOpenOutlinedIcon,
    folderClosed: FolderOutlinedIcon,
    confirm: CheckCircleOutline,
    cancel: CloseIcon,
    page: Description,
    amendment: HistoryRoundedIcon,
    saveChanges: SaveIcon,
    squareChecked: CheckBoxOutlined,
    squareUnchecked: CheckBoxOutlineBlankOutlined,
    openInNew: OpenInNewRoundedIcon,
    attachFile: AttachFileRoundedIcon,
};
